/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";

interface Props {
	searchQuery: string;
	setSearchQuery: (query: string) => void;
}

const ContainerSearch = ({ searchQuery, setSearchQuery }: Props) => {
	const { t } = useTranslation();
	return (
		<div className="bg-slate-50/50 rounded-[1rem] border border-blue-500 border-dashed p-2 relative overflow-hidden">
			<div className="absolute top-0 left-0 w-1 h-[100px] bg-blue-500"></div>
			<div className="grid grid-cols-12 gap-8 items-center">
				<div className="col-span-7">
					<div className="relative group">
						<input
							type="text"
							placeholder={t("mediaBatchInit.dispenseEntry.searchPlaceholder")}
							value={searchQuery}
							onChange={(e) => setSearchQuery(e.target.value)}
							className="w-full bg-white border border-slate-200 rounded-xl py-2.5 pl-10 pr-4 text-[13px] font-bold focus:ring-4 focus:ring-blue-500/5 outline-none transition-all"
						/>
						<span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-blue-500 transition-colors">
							search
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};
export default ContainerSearch;
